var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import { showToastMessage } from "@lonelyplanet/dotcom-core/dist/actions/toast";
import { Heading } from "backpack-ui/dist/components/text";
import * as cn from "classnames";
import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Text from "../../../../shared/components/text";
import _ from "../../../../shared/utils/lodash";
import { Button } from "../../components/button";
import * as styles from "./styles.css";
var getPoiUrl = function () { return typeof window !== "undefined" ? window.location.pathname : ""; };
var Header = function (_a) {
    var title = _a.title, type = _a.type, location = _a.location, topChoice = _a.topChoice, className = _a.className, _b = _a.bookmarked, bookmarked = _b === void 0 ? false : _b, _c = _a.isTour, isTour = _c === void 0 ? false : _c, link = _a.link, onClickBookmark = _a.onClickBookmark, showToast = _a.showToast, rest = __rest(_a, ["title", "type", "location", "topChoice", "className", "bookmarked", "isTour", "link", "onClickBookmark", "showToast"]);
    return (React.createElement("header", __assign({ className: cn(styles.header, className) }, rest),
        React.createElement(Heading, { className: styles.heading, size: 5, level: 1, weight: "medium" }, title),
        React.createElement(Text.Italic, { className: styles.italic },
            topChoice &&
                React.createElement(Text.AccentRed, { element: "em" }, "Top choice"),
            topChoice ? " " + type.toLowerCase() : " " + _.upperFirst(type),
            isTour && location && ", " + location,
            !isTour && location && " in " + location),
        React.createElement("div", { className: styles.headerButtons },
            React.createElement(Button.Bookmark, { bookmarked: bookmarked, onClick: onClickBookmark }),
            React.createElement(Button.Share, { className: styles.headerButtonShare, shareText: title, getPoiUrl: getPoiUrl, showToast: showToast }))));
};
function mapDispatchToProps(dispatch) {
    return {
        showToast: bindActionCreators(showToastMessage, dispatch),
    };
}
export default connect(null, mapDispatchToProps)(Header);



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/patterns/header/index.tsx
// module id = dieY
// module chunks = 2